/**
 * BANK-IBAN-R3.4 / CUSTOMER-R4.6 — in-Mini-App requisites sheet (no first hop to /pay).
 */
import type { StoreV2Lang } from "./store-v2-locale.js";
import { t } from "./store-v2-ui-copy.js";
import type { BankPaymentClientPayload } from "./bank-iban-payment-v2.js";
import { BankPaymentDetailsV2 } from "./BankPaymentDetailsV2.js";
import { BankPayActionsV2 } from "./BankPayActionsV2.js";

export function BankIbanPaymentSheetV2({
  lang,
  open,
  payload,
  onClose,
}: {
  lang: StoreV2Lang;
  open: boolean;
  payload: BankPaymentClientPayload | null;
  onClose: () => void;
}) {
  if (!open || !payload) return null;

  return (
    <div className="sv2-sheet-overlay" role="dialog" aria-modal="true" data-testid="sv2-bank-iban-sheet">
      <button type="button" className="sv2-sheet-backdrop" aria-label={t(lang, "close")} onClick={onClose} />
      <div className="sv2-sheet-panel">
        <div className="sv2-sheet-handle" aria-hidden="true" />
        <h3>{t(lang, "bank_method_title")}</h3>
        <p className="sv2-muted" data-testid="sv2-bank-awaiting" style={{ marginTop: 8 }}>
          {t(lang, "bank_awaiting_confirmation")}
        </p>
        <BankPayActionsV2 lang={lang} payload={payload} testIdPrefix="sv2-bank" />
        <BankPaymentDetailsV2
          lang={lang}
          testId="sv2-bank-copy"
          fields={{
            amountLabel: `${payload.amount_uah} ₴`,
            purpose: payload.purpose,
            seller: payload.seller,
            rnokpp: payload.rnokpp,
            bank: payload.bank,
            iban: payload.iban,
            ibanDisplay: payload.iban_display,
            publicOrderNumber: payload.public_order_number,
          }}
        />
      </div>
    </div>
  );
}
